import { render, staticRenderFns } from "./self-generated-form.vue?vue&type=template&id=52910f6f&scoped=true"
import script from "./self-generated-form.vue?vue&type=script&lang=js"
export * from "./self-generated-form.vue?vue&type=script&lang=js"
import style0 from "./self-generated-form.vue?vue&type=style&index=0&id=52910f6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52910f6f",
  null
  
)

export default component.exports